/**
 * printProvider.js — Proveedor de impresión híbrido (Backend Print Agent + Legacy ZT-Bridge)
 */

import { generarTicketEscPos } from './PrintService_escpos';
import API_URL from '@/utils/api'; // Use centralized config

const DEFAULT_BRIDGE_URL = 'http://localhost:8001';

export const getPrinterServerUrl = () => localStorage.getItem('zt_bridge_url') || DEFAULT_BRIDGE_URL;
export const setPrinterServerUrl = (url) => localStorage.setItem('zt_bridge_url', url);

/**
 * Guarda el nombre de la impresora en localStorage
 */
export const setCustomerPrinter = (name) => localStorage.setItem('zt_bridge_customer', name);
export const setKitchenPrinter = (name) => localStorage.setItem('zt_bridge_kitchen', name);

export const getCustomerPrinter = () => localStorage.getItem('zt_bridge_customer') || '';
export const getKitchenPrinter = () => localStorage.getItem('zt_bridge_kitchen') || '';

/**
 * Imprime un pedido usando exclusivamente el ZT-Bridge local O el nuevo Print Agent (vía Backend).
 */
export const printTicket = async (order, restaurantName = 'Conexo POS', ticketType = 'customer') => {
  const isDemo = sessionStorage.getItem("demo_mode") === "true";
  const token = localStorage.getItem('session_token');

  // MOCK FOR DEMO MODE
  if (isDemo) {
    console.log(`[DemoMode] Pretending to print ${ticketType} for order ${order.order_id}...`);
    return { success: true, method: 'demo_mock' };
  }

  console.log(`[printProvider] Requesting ${ticketType} print for order ${order.order_id} via Agent...`);

  try {
    // NUEVA ESTRATEGIA: Llamar al backend para que el Print Agent recoja el trabajo
    const endpoint = ticketType === 'kitchen'
      ? `${API_URL}/orders/${order.order_id}/reprint/kitchen`
      : `${API_URL}/orders/${order.order_id}/reprint/customer`;

    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if (res.ok) {
      console.log('[printProvider] Impresión encolada con éxito en el Backend');
      return { success: true, method: 'agent' };
    } else {
      console.warn('[printProvider] Backend falló, intentando Bridge local heredado...');
    }
  } catch (e) {
    console.error('[printProvider] Error llamando al Backend:', e.message);
  }

  // FALLBACK: El viejo ZT-Bridge (en caso de que no haya agente configurado)
  const rawText = generarTicketEscPos(order, restaurantName, ticketType);
  const printerName = ticketType === 'kitchen' ? getKitchenPrinter() : getCustomerPrinter();

  try {
    const bridgeUrl = getPrinterServerUrl();
    const bridgeRes = await fetch(bridgeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        printer: printerName,
        data: rawText
      })
    });

    if (bridgeRes.ok) {
      console.log('[printProvider] Impreso con éxito vía ZT-Bridge local');
      return { success: true, method: 'bridge' };
    } else {
      const err = await bridgeRes.json();
      throw new Error(err.error || 'Error en el servidor de impresión local');
    }
  } catch (e) {
    console.error('[printProvider] Error de impresión local:', e.message);
    return {
      success: false,
      error: 'No se pudo imprimir. El Agente no está activo y el Bridge local tampoco responde.'
    };
  }
};


export const printKitchenTicket = (order, restaurantName = 'Conexo POS') =>
  printTicket(order, restaurantName, 'kitchen');

export const printCustomerTicket = (order, restaurantName = 'Conexo POS') =>
  printTicket(order, restaurantName, 'customer');

const printProvider = {
  printTicket,
  printKitchenTicket,
  printCustomerTicket,
  setCustomerPrinter,
  setKitchenPrinter,
  getCustomerPrinter,
  getKitchenPrinter,
  getPrinterServerUrl,
  setPrinterServerUrl
};

export default printProvider;
